import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button, Grid, IconButton } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import Alert from '@material-ui/lab/Alert';
import PermissionHide from 'components/PermissionHide';
import moment from 'moment';
import React, { useCallback } from 'react';
import { FormattedNumber } from 'react-intl';
import { useObservable } from 'react-use-observable';
import refundService from 'v2/services/requestManagement/refund';

import type { IRefund } from 'v2/interfaces/requestManagement/refund';

import useStyle from './styles';

export default function Details() {
  const classes = useStyle();

  const [open] = useObservable(() => refundService.getDetails(), []);
  const [currentRefund] = useObservable(() => refundService.getCurrentRefund(), []);

  const closeDetails = useCallback(() => {
    refundService.closeDetails();
  }, []);

  const refundMotive = useCallback(() => {
    const refund: IRefund = { ...currentRefund };
    refundService.closeDetails();
    refundService.openReproveMotive(refund);
  }, [currentRefund]);

  const approve = useCallback(() => {
    const refund: IRefund = { ...currentRefund };
    refundService.closeDetails();
    refundService.openApprove(refund);
  }, [currentRefund]);

  return (
    <Dialog aria-labelledby='customized-dialog-title' open={open} maxWidth={'sm'}>
      <DialogTitle id='customized-dialog-title'>
        <div className={classes.dialogTitle}>Detalhes do pedido</div>
        <IconButton aria-label='close' className={classes.closeButton} onClick={closeDetails}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <RefundDetails currentRefund={currentRefund} />
      </DialogContent>
      <PermissionHide action='myeduzz:request-management:aprovar'>
        <DialogActions>
          <Button color='primary' onClick={refundMotive}>
            Reprovar Reembolso
          </Button>
          <Button variant='contained' color='secondary' onClick={approve}>
            Aprovar Reembolso
          </Button>
        </DialogActions>
      </PermissionHide>
    </Dialog>
  );
}

export const RefundDetails = ({ currentRefund }: { currentRefund: IRefund }) => {
  const classes = useStyle();
  if (!currentRefund) return null;
  const isExpired = currentRefund.requested_after_deadline;

  return (
    <Grid container spacing={2} direction='row' justify='flex-start' alignItems='center'>
      <Grid item xs={12}>
        <div className={classes.iconText}>
          {isExpired ? <ErrorIcon className={classes.errorIcon} /> : <CheckIcon className={classes.successIcon} />}
          <span>
            Reembolso solicitado em {moment(currentRefund?.created_at).format('DD/MM/YYYY')} -
            {isExpired ? <b> Fora do prazo</b> : <b> Dentro do prazo</b>}
          </span>
        </div>
      </Grid>
      <Grid item xs={12}>
        <Typography gutterBottom className={classes.title}>
          Valor da compra
        </Typography>
        <Typography gutterBottom className={classes.money}>
          <FormattedNumber value={currentRefund?.invoice_value} format='BRL' />
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography gutterBottom className={classes.title}>
          Motivo
        </Typography>
        <Typography gutterBottom className={classes.description}>
          {currentRefund?.request_motive.description}
        </Typography>
      </Grid>

      {currentRefund?.description && (
        <Grid item xs={12}>
          <Typography gutterBottom className={classes.title}>
            Detalhes
          </Typography>
          <Typography gutterBottom className={classes.description}>
            {currentRefund.description}
          </Typography>
        </Grid>
      )}
      <Grid item xs={12}>
        <Alert severity='info'>
          Você tem até o dia <b>{moment(currentRefund?.due_date).format('DD/MM/YYYY')}</b> para aprovar ou reprovar o reembolso.
        </Alert>
      </Grid>
    </Grid>
  );
};
